import React, { useEffect, useState } from 'react';
import { Form, Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import {
  getNotificationList,
  markNotificationsAsViewed,
  deleteNotification,
  deleteAllNotifications,
} from '../../../../../../general_redux/notifications/actions';

import Loading from '../../../../../../components/loading';
import Table from '../../../Channel/Components/Tables/Table';
import { TNotificationInfo, TActionButtons } from './components';
import ReservationCreatedModal from '../Modals/ReservationCreatedModal/ReservationCreatedModal';
import ReservationUpdatedModal from '../Modals/ReservationUpdatedModal/ReservationUpdatedModal';
import ReservationRequestModal from '../Modals/ReservationRequestModal/ReservationRequestModal';
import ReservationCancelledModal from '../Modals/ReservationCancelledModal/ReservationCancelledModal';
import ReservationNotFoundModal from '../Modals/ReservationNotFoundModal/ReservationNotFoundModal';
import RentalNotFoundModal from '../Modals/RentalNotFoundModal/RentalNotFoundModal';
import GuestModifiedModal from '../Modals/GuestModifiedModal/GuestModifiedModal';
import SettingsMismatchModal from '../Modals/SettingsMismatchModal/SettingsMismatchModal';
import ConfirmDeleteModal from '../Modals/ConfirmDeleteModal/ConfirmDeleteModal';
import MarkAsViewedModal from '../Modals/MarkAsViewedModal/MarkAsViewedModal';
import OtherEventsModal from '../Modals/OtherEventsModal/OtherEventsModal';
import notificationEventType from '../../../../../../config/data/notificationTypes';

import styles from './NotificationView.module.css';


const NotificationView = (props) => {

  const dispatch = useDispatch();

  const notifications = useSelector(({ notifications }) => notifications && notifications.notifications).filter(notifications => notifications.notifyInApp);
  const actionForGetNotificationList = useSelector(({ notifications }) => notifications && notifications.actionForGetNotificationList);

  const [notificationData, setNotificationData] = useState(null);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [markAsViewedModal, setMarkAsViewedModal] = useState(false);
  const [notificationEventModal, setNotificationEventModal] = useState(false);
  const [filter, setFilter] = useState('All');

  const cols = [
    { label: 'Message', key: 'message', component: 'TNotificationInfo' },
    { label: 'Actions', key: '', component: 'TActionButtons' },
  ];

  useEffect(() => {
    dispatch(getNotificationList());
  }, [filter]);

  const filterNotifications = (notifications) => {
    let filteredList = notifications;
    if (filter === 'New') {
      filteredList = notifications.filter((item) => item.status === 'New');
    };
    if (filter === 'Viewed') {
      filteredList = notifications.filter((item) => item.status === 'Viewed');
    };
    return filteredList;
  };

  const handleSelect = (e) => {
    setFilter(e.target.value);
  };

  const handleView = (data) => {
    const payload = { notificationIdList: [data.id] };
    dispatch(markNotificationsAsViewed(payload));
    setNotificationData(data);
    setNotificationEventModal(data.type);
  };

  const handleMarkAllAsViewed = () => {
    const payload = { notificationIdList: notifications.map(item => item.id) };
    dispatch(markNotificationsAsViewed(payload));
  };

  const handleDelete = (id) => {
    dispatch(deleteNotification(id));
  };

  const handleDeleteAll = () => {
    dispatch(deleteAllNotifications());
  };
  
  return (
    <div>
      <Loading loadingStatus={actionForGetNotificationList.loading} />
      <Container fluid>
        {notifications.length ? (
          <Row className='justify-content-left'>
            <Col xs={12} md={8} lg={10} xl={6} className='m-0 p-0'>
              <Row className='m-0 p-0 pl-1 mt-3 mb-4 justify-content-between'>
                <Form.Row className='py-1'>
                  <Form.Label className='col-form-label'>Filter:</Form.Label>
                  <Col>
                    <Form.Control
                      as='select'
                      type='text'
                      name='filter'
                      value={filter}
                      onChange={handleSelect}
                      style={{ fontSize: 'inherit' }}
                    >
                      {['All', 'New', 'Viewed'].map((option, index) => (
                        <option key={index} value={option} selected={filter === option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                </Form.Row>
                <div className={styles.buttonContainer}>
                  <button
                    onClick={() => setMarkAsViewedModal(true)}
                    className={styles.buttons}
                  >
                    Mark All Viewed
                  </button>
                  <button
                    onClick={() => setConfirmDeleteModal(true)}
                    className={`${styles.buttons} ${styles.deleteButton}`}
                  >
                    Delete All
                  </button>
                </div>
              </Row>
              <Table
                cols={cols}
                rows={[...filterNotifications(notifications)].reverse()} // sort by most recent
                tableName={'notification'}
                handleDelete={(data) => {
                  setNotificationData(data);
                  setConfirmDeleteModal(true);
                }}
                handleView={handleView}
                TNotificationInfo={TNotificationInfo}
                TActionButtons={TActionButtons}
              />
            </Col>
          </Row>
        ) : (
          <Row className='justify-content-left'>
            <p style={{ fontSize: '20px', margin: '10px 0 0 15px' }}>
              No notifications available.
            </p>
          </Row>
        )}
      </Container>

      <ConfirmDeleteModal
        mode={'notification'}
        show={confirmDeleteModal}
        onHide={() => {
          setConfirmDeleteModal(false);
          setNotificationData(null);
        }}
        values={notificationData}
        handleDelete={handleDelete}
        handleDeleteAll={handleDeleteAll}
      />

      <MarkAsViewedModal
        show={markAsViewedModal}
        onHide={() => setMarkAsViewedModal(false)}
        handleMarkAllAsViewed={handleMarkAllAsViewed}
      />

      <OtherEventsModal
        mode={'notification'}
        show={
          [
            notificationEventType.NEW_FEATURE_AVAILABLE,
            notificationEventType.OTA_CONNECTION_ERROR,
            notificationEventType.BEEHAZ_ERROR,
            notificationEventType.DOUBLE_BOOKING,
          ].includes(notificationEventModal)
        }
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        values={notificationData}
      />

      <SettingsMismatchModal
        mode={'notification'}
        show={notificationEventModal === notificationEventType.BEEHAZ_SETTINGS_DIFFER_FROM_OTA}
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />
      
      <GuestModifiedModal
        mode={'notification'}
        show={notificationEventModal === notificationEventType.CHANGE_OF_GUEST_DETAILS}
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />

      <ReservationCreatedModal
        mode={'notification'}
        show={notificationEventModal === notificationEventType.RESERVATION_CREATED}
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />
      <ReservationUpdatedModal
        mode={'notification'}
        show={notificationEventModal === notificationEventType.RESERVATION_UPDATED}
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />
      <ReservationRequestModal
        mode={'notification'}
        show={notificationEventModal === notificationEventType.RESERVATION_REQUEST}
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />
      <ReservationCancelledModal
        mode={'notification'}
        show={notificationEventModal === notificationEventType.RESERVATION_CANCELLED}
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />
      <ReservationNotFoundModal
        mode={'notification'}
        show={
          [
            notificationEventType.RESERVATION_NOT_FOUND_TO_UPDATE_RESERVATION,
            notificationEventType.RESERVATION_NOT_FOUND_TO_DELETE_RESERVATION,
          ].includes(notificationEventModal)
        }
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />
      <RentalNotFoundModal
        mode={'notification'}
        show={
          [
            notificationEventType.RENTAL_NOT_FOUND_TO_CREATE_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_UPDATE_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_REQUEST_RESERVATION,
            notificationEventType.RENTAL_NOT_FOUND_TO_DELETE_RESERVATION,
          ].includes(notificationEventModal)
        }
        onHide={() => {
          setNotificationEventModal(false);
          setNotificationData(null);
        }}
        handleDelete={handleDelete}
        values={notificationData}
      />

    </div>
  );
};

export default NotificationView;